<script setup lang="ts">
import { PV } from "@/widgets";
import Icon from "~icons/mdi/check-bold";

defineEmits<{
    click: [];
}>();
</script>

<template>
    <PV.Button v-tooltip.left="'Simpan'" class="p-0!" link @click="$emit('click')">
        <Icon class="bg-green-500 text-white rounded-sm p-0.5 hover:cursor-pointer" />
    </PV.Button>
</template>
